<app-internal-page [backRouterLink]="getBackRouterLink()">
    <div content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.xs="15px">
        <span class="mat-title">Data e horário:</span>
        <mat-form-field appearance="outline">
            <mat-label>Mês e ano</mat-label>
            <mat-select 
                [(ngModel)]="selectedPeriodMonth" 
                (selectionChange)="filterMonthChanged()" 
                [compareWith]="compareObjects">
                <mat-option *ngFor="let month of periodMonthsData" [value]="month">
                    {{month.start_date | date: 'MMMM - yyyy' | titlecase}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <ng-container *ngIf="availableHoursData && availableHoursData.length; else noAvailableHours">

            <ng-container *ngFor="let date of availableHoursData | slice:0:limitDays">
                <div class="mat-title available-hours-title" 
                    fxLayoutAlign="space-between center">
                    <span>
                        {{date.date | date: 'dd/MM,'}}
                        <span class="available-hours-title-weekday">
                            {{date.date | date: ' EEEE'}}
                        </span>
                    </span>
                    <span class="icon-click" (click)="onDateCollapseClick(date)" class="fa fa-{{date.showMore ? 'caret-up' : 'caret-down'}}"></span>
                </div>
    
                <div class="available-hours-container" 
                    fxLayout="row" 
                    fxLayoutAlign="space-between start" 
                    fxLayoutGap="30px"
                    fxLayoutGap.xs="10px">
    
                    <div fxFlex="50%" *ngFor="let period of date.periods" fxLayout="column">
                        <mat-chip-list class="mat-chip-list-stacked">
                            <mat-chip 
                                [selectable]="true"
                                color="primary"
                                (click)="onAvailableHourClick(availableHour)"
                                [selected]="isSelected(date.date, availableHour.start_time)"
                                *ngFor="let availableHour of period | slice:0:(date.showMore ? period.length : 2);">
                                {{availableHour.start_time | date: 'HH:mm':'+0000'}}
                                - 
                                {{availableHour.end_time | date: 'HH:mm':'+0000'}}
                            </mat-chip>
                        </mat-chip-list>
                    </div>
                </div>
            </ng-container>

            <div fxLayoutAlign="center"
                *ngIf="availableHoursData">
                <button color="primary" (click)="onMoreDays()" [disabled]="!showMoreDaysButton()" mat-flat-button>
                    Mostrar mais
                </button>
            </div>
        </ng-container>

        <ng-template #noAvailableHours>
            <span
                *ngIf="availableHoursData && !availableHoursData.length" 
                class="message-warn" 
                fxLayout="row" 
                fxLayoutAlign="center center" 
                fxLayoutGap="14px">
                <app-icon-circle faIcon="exclamation"></app-icon-circle>
                <span>
                    Não existem horários disponíveis neste mês, por favor, selecione outro.
                </span>
            </span>
        </ng-template>
    </div>
</app-internal-page>
